import React from "react";
import './NewEmployeeForm.css'
import employeesData from '../../Pool/data'
import CreatableSelect from 'react-select/creatable'

class NewEmployeeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            queryName: '',
            querySurname: '',
            queryDepartment: '',
            querySalary: '',
            queryCurrency: ''
        };
    }

    handleAddNewEmployee = (e) => {
        e.preventDefault();

        const newEmployee = {
            imie: this.state.queryName && this.state.queryName[0].toUpperCase() + this.state.queryName.toLowerCase().slice(1),
            nazwisko: this.state.querySurname && this.state.querySurname[0].toUpperCase() + this.state.querySurname.toLowerCase().slice(1),
            dzial: this.state.queryDepartment && this.state.queryDepartment.value[0].toUpperCase() + this.state.queryDepartment.value.slice(1),
            wynagrodzenieKwota: this.state.querySalary,
            wynagrodzenieWaluta: this.state.queryCurrency && this.state.queryCurrency.toUpperCase()
        };
        if (this.state.queryName && this.state.querySurname && this.state.queryDepartment && this.state.querySalary && this.state.queryCurrency) {

            employeesData.PRACOWNICY.push(newEmployee);
            this.props.changeRefreshFlag();
            this.clearForm();
        } else {
            alert('Wypełnij wszystkie pola danymi!')
        }
    };

    clearForm = () => {
        this.setState({
            queryName: '',
            querySurname: '',
            queryDepartment: '',
            querySalary: '',
            queryCurrency: ''
        })
    };

    render() {
        return (
            <form className="needs-validation mx-3 mt-3" noValidate>
                <div className="form-row">
                    <div className="col-md-4 mb-3">
                        <label htmlFor="validationCustom01"
                               className='font-weight-bold general-color font-italic '>Imię:</label>
                        <input type="text" className="form-control" id="validationCustom01" placeholder="Imię"
                               value={this.state.queryName} onChange={(e) => {
                            const queryName = e.target.value;
                            this.setState({
                                queryName,
                            })
                        }} required/>
                        <div className="valid-feedback">
                            Looks good!
                        </div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label htmlFor="validationCustom02"
                               className='font-weight-bold general-color font-italic '>Nazwisko:</label>
                        <input type="text" className="form-control" id="validationCustom02" placeholder="Nazwisko"
                               value={this.state.querySurname} onChange={(e) => {
                            const querySurname = e.target.value;
                            this.setState({
                                querySurname,
                            })
                        }} required/>
                        <div className="valid-feedback">
                            Looks good!
                        </div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label htmlFor="validationCustom02"
                               className='font-weight-bold general-color font-italic '>Dział:</label>
                        <CreatableSelect
                            isClearable
                            placeholder='Dział'
                            onChange={(e) => {
                                const queryDepartment = e;
                                this.setState({
                                    queryDepartment,
                                }, () => {
                                })
                            }}
                            options={this.props.departmentsList}
                        />
                        <div className="valid-feedback">
                            Looks good!
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom03" className='font-weight-bold general-color font-italic '>Kwota
                            wynagrodzenia:</label>
                        <input
                            type='number'
                            pattern="[0-9]*"
                            inputMode='numeric'
                            className="form-control" id="validationCustom03"
                            placeholder="Kwota wynagrodzenia"
                            value={this.state.querySalary} onChange={(e) => {
                            const querySalary = e.target.value;
                            this.setState({
                                querySalary,
                            })
                        }}
                            required/>
                        <div className="invalid-feedback">
                            Please provide a valid city.
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <label htmlFor="validationCustom04" className='font-weight-bold general-color font-italic '>Waluta
                            wynagrodzenia:</label>
                        <input type="text" className="form-control" id="validationCustom04"
                               placeholder="Waluta wynagrodzenia"
                               value={this.state.queryCurrency} onChange={(e) => {
                            const queryCurrency = e.target.value;
                            this.setState({
                                queryCurrency,
                            })
                        }}
                               required/>
                        <div className="invalid-feedback">
                            Please provide a valid state.
                        </div>
                    </div>
                </div>
                <div className="col text-center">
                    <button className="btn btn-primary btn-width" type="submit"
                            onClick={this.handleAddNewEmployee}>Dodaj
                    </button>
                </div>
            </form>
        )
    }

}


export default NewEmployeeForm